import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SearchBookPage from "./SearchBookPage";
import SearchBookForm from "./SearchBookForm";
import { handleGoogleSearch, performSearch } from "./GoogleSearchQuery";
import PropTypes from 'prop-types';
import {useBooks} from "../State/bookContext";

const SearchBook = () => {
    const location = useLocation();
    const { books, setBooks } = useBooks();
    const [error, setError] = useState(null);
    const [title, setTitle] = useState(location.state?.initialQuery || '');
    const [author, setAuthor] = useState('');

    useEffect(() => {
        if (!title.trim()) return;
        const timer = setTimeout(() => {
            performSearch(title, author || null, setBooks, null, setError);
        }, 3000);
        return () => clearTimeout(timer);
    }, [title, author]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearch = (e) => handleGoogleSearch(e, setBooks, null, setError);

    const currentPath = location.pathname;
    const isSearchPage = currentPath === '/searchBook';

    return (
        <>
            {error && (
                <div className="mb-4 bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg px-4 py-3">
                    {error}
                </div>
            )}
            {isSearchPage && books.length > 0 ? (
                <SearchBookPage
                    books={books}
                    handleSearch={handleSearch}
                    title={title} setTitle={setTitle}
                    author={author} setAuthor={setAuthor}
                />
            ) : (
                <SearchBookForm
                    handleSearch={handleSearch}
                    title={title} setTitle={setTitle}
                    author={author} setAuthor={setAuthor}
                />
            )}
        </>
    );
};

SearchBook.propTypes = {
    initialBooks: PropTypes.arrayOf(PropTypes.object),
};

export default SearchBook;